import { useState } from 'react'
import { BellRing, ChevronLeft, ClipboardList, LayoutDashboard, Menu as MenuIcon, QrCode, Settings } from 'lucide-react'
import { BrandMark } from '../../components/BrandMark'
import { useAppStore } from '../../store/MockAppStore'
import { DashboardOverview } from './DashboardOverview'
import { MenuManager } from './MenuManager'
import { QrStudio } from './QrStudio'
import { RequestQueue } from './RequestQueue'
import { SettingsPanel } from './SettingsPanel'

type StaffView = 'overview' | 'requests' | 'menu' | 'qr' | 'settings'
const nav = [
  { id: 'overview' as const, label: 'Overview', icon: LayoutDashboard },
  { id: 'requests' as const, label: 'Requests', icon: BellRing },
  { id: 'menu' as const, label: 'Menu', icon: ClipboardList },
  { id: 'qr' as const, label: 'QR codes', icon: QrCode },
  { id: 'settings' as const, label: 'Settings', icon: Settings },
]

export function StaffDashboard({ goToClient }: { goToClient: () => void }) {
  const [view, setView] = useState<StaffView>('overview')
  const [mobileMenu, setMobileMenu] = useState(false)
  const { requests, settings, environmentMode } = useAppStore()
  const pending = requests.filter((request) => request.status === 'pending').length
  const initials = settings.displayName.split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]).join('').toUpperCase() || 'S'
  return (
    <div className="staff-shell">
      <aside className={`staff-sidebar ${mobileMenu ? 'staff-sidebar--open' : ''}`}>
        <BrandMark />
        <p className={`preview-label preview-label--${environmentMode}`}><span>{environmentMode === 'live' ? 'Protected area' : environmentMode === 'prelaunch' ? 'Pre-launch environment' : 'Local preview'}</span> {environmentMode === 'live' ? 'Cloudflare Access required' : environmentMode === 'prelaunch' ? 'Live services are not verified' : 'Not for production use'}</p>
        <nav aria-label="Staff dashboard">
          {nav.map((item) => <button className={view === item.id ? 'active' : ''} key={item.id} onClick={() => { setView(item.id); setMobileMenu(false) }}><item.icon size={18} /><span>{item.label}</span>{item.id === 'requests' && pending > 0 && <b>{pending}</b>}</button>)}
        </nav>
        <div className="stylist-card"><span>{initials}</span><div><strong>{settings.displayName}</strong><small>Salon concierge</small></div></div>
        <button className="back-to-client" onClick={goToClient}><ChevronLeft size={17} />View client concierge</button>
      </aside>
      {mobileMenu && <button className="sidebar-scrim" onClick={() => setMobileMenu(false)} aria-label="Close navigation" />}
      <header className="staff-mobile-header"><button className="icon-button" onClick={() => setMobileMenu(true)} aria-label="Open navigation"><MenuIcon /></button><BrandMark compact /><span className="pending-count">{pending}</span></header>
      <main className="staff-content">
        {view === 'overview' && <DashboardOverview openRequests={() => setView('requests')} />}
        {view === 'requests' && <RequestQueue />}
        {view === 'menu' && <MenuManager />}
        {view === 'qr' && <QrStudio />}
        {view === 'settings' && <SettingsPanel />}
      </main>
      <nav className="staff-bottom-nav" aria-label="Mobile staff navigation">{nav.slice(0, 4).map((item) => <button className={view === item.id ? 'active' : ''} key={item.id} onClick={() => setView(item.id)}><item.icon size={20} /><span>{item.label}</span></button>)}</nav>
    </div>
  )
}
